import {Route, BrowserRouter, Routes,} from "react-router-dom";
import Maintenance from "../Pages/maintenance";
import Home from "../Pages/Home";
import Saulo from "../Pages/Saulo";


const Rotas = () => {
    return(
        
        <BrowserRouter>
            <Routes>
                <Route element = { <Home/> } path="/" exact/>
                <Route element = { <Saulo/> } path="/saulo"/>
            </Routes>
        </BrowserRouter>
        
    )
}



export default Rotas;